import { useEffect } from 'react';
import { throttle } from 'lodash';
import { useReframe } from 'nike-re-framejs';
import { route$ } from '@/routing/subs';

export enum SCROLL_CLASS {
    up = 'scroll-page-up',
    down = 'scroll-page-down'
}

const pageClassNames = document.body.classList;

const removeScrollClasses = () => pageClassNames.remove(SCROLL_CLASS.up, SCROLL_CLASS.down);

const useOnScroll = (): void => {
    const derefSub = useReframe();
    const route = derefSub(route$);
    useEffect(() => {
        removeScrollClasses();
    }, [route]);
    const minDiff = 30;
    useEffect(() => {
        let prevYPos = window.scrollY;
        const minScrollDif = (currentYPos: number) => Math.abs(currentYPos - prevYPos) > minDiff;
        const updateScrollDirection = () => {
            const currentYPos = window.scrollY;
            if (currentYPos === 0) {
                removeScrollClasses();
            } else if (minScrollDif(currentYPos)) {
                const scrollPos = currentYPos > prevYPos;
                pageClassNames.toggle(SCROLL_CLASS.down, scrollPos);
                pageClassNames.toggle(SCROLL_CLASS.up, !scrollPos);
                prevYPos = currentYPos;
            }
        };
        const onScroll = throttle(() => window.requestAnimationFrame(updateScrollDirection), 300);

        window.addEventListener('scroll', onScroll);
        return () => {
            removeScrollClasses();
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
};

export default useOnScroll;
